<template>
  <div>
    <div v-if="guardError"
         class="alert alert-warning"
         v-html="guardError"
    >
    </div>
    <label for="state-change-comment">Komentář ke změně stavu</label>
    <textarea v-model="comment"
              if="state-change-comment"
              class="comment"
    >
    </textarea>
    <div v-if="currentState"
         class="state-selector"
    >
      <ActiveButton v-if="showResetButton"
                    class="asd-btn-delete"
                    :confirmText="`Opravdu chcete resetovat cele workflow?`"
                    :click="resetWorkflow"
      >
        <i class="fas fa-redo"></i> Reset Workflow
      </ActiveButton>
      <button v-for="c in availableConnections"
              :key="c.id"
              class="asd-btn-confirm"
              @click="performConnection(c)"
      >
        {{ c.label }} <i class="fas fa-angle-double-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { get, find, head, filter, indexOf, size, has, defaultTo } from 'lodash'
import { createDataTypeValue } from 'CORE/components/data-type/utils'
import { currentTimestamp } from 'CORE/utils/date'
import { entityQuery } from '@/main'
import ActiveButton from 'CORE/components/form/active-button'
import EventBus from 'CORE/bus'

export default {
    name: 'EntityStateEditor',
    components: {
        ActiveButton,
    },
    props: {
        graphId: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: false,
            default: _ => createDataTypeValue(null),
        },
    },
    data() {
        return {
            propertyType: undefined,
            comment: undefined,
            guardError: undefined,
        }
    },
    computed: {
        valueHandler: {
            get() {
                return get(this, 'value.value.value', null)
            },
            set(value) {
                this.$emit('input', createDataTypeValue(value))
            },
        },
        graph() {
            const graph = get(this.$store.getters.currentUser, `company.settings.entity-states.graphs.${this.graphId}`, {})
            return graph
        },
        states() {
            return get(this.$store.getters.currentUser, `company.settings.entity-states.states`, {})
        },
        currentState() {
            return find(this.states, s => s.id === this.valueHandler)
        },
        availableConnections() {
            return filter(this.graph.connections, c => {
                return c.from === this.valueHandler && c.event === 'manually'
            })
        },
        showResetButton() {
            if (this.$store.getters.groupedActions.includes('RESET_WORKFLOW')) {
                return true
            }
            return false
            // const currentStateId = get(this.currentState, 'id')
            // const currentlyAvailableStates = get(this.graph, 'states', [])
            // if (indexOf(currentlyAvailableStates, currentStateId) === -1) {
            //     return true
            // }
            // return false
        },
    },
    methods: {
        performConnection(connection) {
            if (this.evaluateGuards(connection)) {
                if (!has(this.value.value, 'history')) {
                    this.$set(this.value.value, 'history', [])
                }
                this.value.value.history.push({
                    user: this.$store.getters.currentUser.id,
                    comment: this.comment,
                    date: currentTimestamp(),
                    from: find(this.states, { id: connection.from }),
                    to: find(this.states, { id: connection.to }),
                })
                this.comment = undefined
                this.$set(this.value.value, 'value', connection.to)
                this.$emit('input', this.value)
                this.$emit('done')
            }
        },
        evaluateGuards(connection) {
            const guards = get(connection, 'guards', [])
            if (indexOf(guards, 'must_comment_event') >= 0) {
                if (this.comment === undefined || size(this.comment) === 0) {
                    this.guardError = `<strong>${connection.label}</strong> vyžaduje vyplnění komentáře.`
                    return false
                }
            }
            if (indexOf(guards, 'only_author') >= 0) {
                const author = entityQuery.onePropertyByTag(this.entity, 'author')
                if (author.isEmpty) {
                    return true
                }
                const authorId = head(author.singleValue)
                if (this.$store.getters.currentUser.id !== authorId) {
                    this.guardError = `<strong>${connection.label}</strong> může provést pouze autor.`
                    return false
                }
            }
            return true
        },
        async resetWorkflow() {
            const defaultStateId = get(this.graph, 'defaultState')

            this.value.value.history.push({
                user: this.$store.getters.currentUser.id,
                comment: 'AUTOMATICKÝ KOMENTÁŘ: administrátorský reset' + defaultTo(this.comment, ''),
                date: currentTimestamp(),
                from: find(this.states, { id: get(this.currentState, 'id') }),
                to: find(this.states, { id: defaultStateId }),
            })
            this.comment = undefined
            this.$set(this.value.value, 'value', defaultStateId)
            this.$emit('input', this.value)
            this.$emit('done')
            EventBus.$emit('FLASH_INFO', { message: `Workflow vyresetováno, prosím uložte nyní.` })
        },
    },
}
</script>

<style scoped lang="scss">
.comment {
    width: 100%;
    border: 1px solid var(--color-input-border);
    border-radius: 3px;
    min-height: 200px;
    padding: 10px;
}
.state-selector:not(:empty) {
    display: flex;
    justify-content: space-evenly;
    min-height: 3rem;
    border-radius: 3px;
    & > * {
        align-self: center;
    }
}
</style>

